import { Modal } from "@sicredi/react";
import { IModalAccountAgency } from "./model";

export const NotFoundModal: React.FC<IModalAccountAgency> = ({
  isOpen,
  setIsOpen,
}) => {
  return (
    <div>
      <Modal
        title="Agência e Conta não encontrada"
        onClose={async () => setIsOpen(false)}
        show={isOpen}
        primaryButton={{
          children: "Entendi",
          onClick: async () => setIsOpen(false),
        }}
      >
        Verifique a digitação da sua cooperativa e conta com o dígito. Necessita
        ser de sua titularidade e não é permitido conta poupança ou salário.
      </Modal>
    </div>
  );
};
